<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          Vous retrouverez ici les rapports utiles à la gestion des accès sur site.
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    redirectUrl: 'https://bi.heig-vd.ch'
  })
};
</script>
